export const MAX_SELECTIONS_TO_DISPLAY = 3;
export const MAX_VEHICLES_TO_DISPLAY = 20;
